module.exports = FormData;


//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-form-data/lib/browser.js
// module id = 775
// module chunks = 0